import React, { useContext } from "react";
import { Link } from "react-router-dom";
import {
  FaceBookIcon,
  InstagramIcon,
  WhatsAppIcon,
  LinkedInIcon,
  TwitterIcon,
  YoutubeIcon,
  SkypeIcon,
  SnapChatIcon,
  TikTokIcon,
  CompanyProfileIcon,
} from "../SvgIcon";
import { CardContext } from "../../../store/CardContext";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";

function SocialMediaIconicGrid({ preview, Textcolor, BtIColor }) {
  const [cardData] = useContext(CardContext);
  const { socialMedias } = cardData;

  const socialMediaSvg = [
    { name: "Facebook", icon: FaceBookIcon },
    { name: "Instagram", icon: InstagramIcon },
    { name: "Whatsapp", icon: WhatsAppIcon },
    { name: "LinkedIn", icon: LinkedInIcon },
    { name: "Twitter", icon: TwitterIcon },
    { name: "Youtube", icon: YoutubeIcon },
    { name: "Skype", icon: SkypeIcon },
    { name: "Snapchat", icon: SnapChatIcon },
    { name: "Tiktok", icon: TikTokIcon },
    { name: "Company Profile", icon: CompanyProfileIcon },
  ];

  const getDetailsByName = (socialMediaName) => {
    const socialMedia = socialMediaSvg.find(
      (option) => option.name.toLowerCase() === socialMediaName.toLowerCase()
    );
    return socialMedia ? socialMedia : null;
  };

  const getGridClass = () => {
    const count = socialMedias?.length || 0;
    if (count === 1) return "grid grid-cols-1";
    if (count === 2) return "grid grid-cols-1 md:grid-cols-2";
    if (count === 4) return "grid grid-cols-3 md:grid-cols-3"; // Custom grid for 4 items
    return "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
  };

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button, id) => {
    // console.log("iiii", id);

    updateTapCount(queryClient, button, id);
  };

  return (
    <div className={`${getGridClass()} items-center p-2 gap-3`}>
      {socialMedias?.map((media, index) => {
        const details = getDetailsByName(media?.platform);
        const isLastItem = index === socialMedias.length - 1; // Check if it's the last item
        return (
          <Link
            key={index}
            onClick={() => handleTap('socialMedias', media._id)}
            to={`${preview ? (media.platform === 'Whatsapp' ? `https://wa.me/+${media?.link}?text=Hi%2C` : media?.link) : ""}`}
            target={`${preview ? "_blank" : ""}`}
            rel="noopener noreferrer"
          >
            <div
              className={`h-[139px] border-[#F2F2F2] border rounded-[12px] items-center p-8 ${isLastItem ? "col-span-3 md:col-span-3" : ""
                }`}
            >
              <div className="flex items-center justify-center h-[54px]" >
                {details?.icon}
              </div>
              <p className="text-[12px]  font-medium text-center" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                {details?.name}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default SocialMediaIconicGrid;



// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaceBookIcon,
//   InstagramIcon,
//   WhatsAppIcon,
//   LinkedInIcon,
//   TwitterIcon,
//   YoutubeIcon,
//   SkypeIcon,
//   SnapChatIcon,
//   TikTokIcon,
//   CompanyProfileIcon,
// } from "../SvgIcon";
// import { CardContext } from "../../../store/CardContext";

// function SocialMediaIconicGrid({ preview }) {
//   const [cardData] = useContext(CardContext);
//   const { socialMedias } = cardData;

//   const socialMediaSvg = [
//     { name: "Facebook", icon: FaceBookIcon },
//     { name: "Instagram", icon: InstagramIcon },
//     { name: "Whatsapp", icon: WhatsAppIcon },
//     { name: "LinkedIn", icon: LinkedInIcon },
//     { name: "Twitter", icon: TwitterIcon },
//     { name: "Youtube", icon: YoutubeIcon },
//     { name: "Skype", icon: SkypeIcon },
//     { name: "Snapchat", icon: SnapChatIcon },
//     { name: "Tiktok", icon: TikTokIcon },
//     { name: "Company Profile", icon: CompanyProfileIcon },
//   ];

//   const getDetailsByName = (socialMediaName) => {
//     const socialMedia = socialMediaSvg.find(
//       (option) => option.name.toLowerCase() === socialMediaName.toLowerCase()
//     );
//     return socialMedia ? socialMedia : null;
//   };

//   const renderSocialMediaItem = (media, index) => {
//     const details = getDetailsByName(media?.platform);
//     return (
//       <Link
//         key={index}
//         to={`${
//           preview
//             ? media.platform === "Whatsapp"
//               ? `https://wa.me/+${media?.link}?text=Hi%2C`
//               : media?.link
//             : ""
//         }`}
//         target={preview ? "_blank" : ""}
//         rel="noopener noreferrer"
//         className="w-full"
//       >
//         <div className="h-[139px] border-[#F2F2F2] border rounded-[12px] items-center p-8">
//           <div className="flex items-center justify-center h-[54px]">
//             {details?.icon}
//           </div>
//           <p className="text-[12px] text-black font-medium text-center">
//             {details?.name}
//           </p>
//         </div>
//       </Link>
//     );
//   };

//   if (socialMedias.length === 1) {
//     return (
//       <div className="grid grid-cols-1 w-[20px] p-2">
//         {renderSocialMediaItem(socialMedias[0], 0)}
//       </div>
//     );
//   }

//   if (socialMedias.length === 2) {
//     return (
//       <div className="grid grid-cols-2 w-full p-2 gap-3">
//         {socialMedias.map((media, index) => renderSocialMediaItem(media, index))}
//       </div>
//     );
//   }

//   return (
//     <div className="grid grid-cols-3 w-full p-2 gap-3">
//       {socialMedias.map((media, index) => renderSocialMediaItem(media, index))}
//     </div>
//   );
// }

// export default SocialMediaIconicGrid;
